export const meetingStatus = {
  DRAFT: "DRAFT", // simulcast
  INITIAL: "INITIAL", // local
  ENTRY: "ENTRY", // local
  DECLARED: "DECLARED",
  DEFINED: "DEFINED",
  STARTED: "STARTED",
  CLOSED: "CLOSED",
  ENTRY_ABANDON: "ENTRY_ABANDON", // local
  ABANDON: "ABANDON",
  ABANDON_PARTIAL: "ABANDON_PARTIAL",
};
export const raceStatus = {
  DRAFT: "DRAFT",
  DECLARED: "DECLARED",
  // NAMED: "NAMED",
  CLOSED: "CLOSED",
  RESULT: "RESULT",
  VOIDED: "VOIDED",
  ABANDONED: "ABANDONED",
};
export const runnerStatus = {
  DECLARED: "Declared",
  SCRATCHED: "Scratched",
  DRAFTSTANDBY: "DraftStandby",
  STANDBY: "Standby",
  SCRATCHEDRESERVED: "ScratchedReserved",
};
export const pmPoolStatus = {
  INITIAL: "INITIAL",
  DEFINED: "DEFINED",
  REMOVED: "REMOVED",
  START_SELL: "START_SELL",
  STOP_SELL: "STOP_SELL",
  CLOSED: "CLOSED",
  CLOSED_AFTER_REFUND: "CLOSED_AFTER_REFUND",
  PAYOUT: "PAYOUT",
  REFUND_BEFORE_CLOSE: "REFUND_BEFORE_CLOSE",
  REFUND_AFTER_CLOSE: "REFUND_AFTER_CLOSE"
}
export const raceResultStatus = {
  CAP: "CAP",
  PARTIAL: "PARTIAL",
  FULLFIELDPLACING: "FULLFIELDPLACING",
  WCFULLMARGIN: "WCFULLMARGIN",
  VOIDED: "VOIDED",
  OFFICIAL: "OFFICIAL",
  COMPLETED: "COMPLETED",
}